import api from './api';

class RoleService {
  // Get all roles with pagination and filtering
  static async getRoles(params = {}) {
    try {
      //console.log('=== RoleService.getRoles START ===');
      //console.log('RoleService.getRoles called with params:', params);
      //console.log('API base URL:', api.defaults.baseURL);
      //console.log('API headers:', api.defaults.headers);
      //console.log('Making API call to /roles');
      
      const response = await api.get('/roles', { params });
      
      //console.log('API response received:', response);
      //console.log('Response status:', response.status);
      //console.log('Response headers:', response.headers);
      //console.log('Response data:', response.data);
      //console.log('Response data type:', typeof response.data);
      //console.log('Response data keys:', Object.keys(response.data || {}));
      
      //console.log('=== RoleService.getRoles END ===');
      return response.data;
    } catch (error) {
      console.error('=== RoleService.getRoles ERROR ===');
      console.error('Error fetching roles:', error);
      console.error('Error type:', typeof error);
      console.error('Error name:', error.name);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      console.error('Error response:', error.response);
      console.error('Error response status:', error.response?.status);
      console.error('Error response data:', error.response?.data);
      console.error('Error config:', error.config);
      console.error('=== RoleService.getRoles ERROR END ===');
      throw error;
    }
  }

  // Get role by ID
  static async getRoleById(id) {
    try {
      const response = await api.get(`/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching role:', error);
      throw error;
    }
  }

  // Create new role
  static async createRole(roleData) {
    try {
      const response = await api.post('/roles', roleData);
      return response.data;
    } catch (error) {
      console.error('Error creating role:', error);
      throw error;
    }
  }

  // Update role
  static async updateRole(id, roleData) {
    try {
      const response = await api.put(`/roles/${id}`, roleData);
      return response.data;
    } catch (error) {
      console.error('Error updating role:', error);
      throw error;
    }
  }

  // Delete role
  static async deleteRole(id) {
    try {
      const response = await api.delete(`/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting role:', error);
      throw error;
    }
  }

  // Get available permissions
  static async getAvailablePermissions() {
    try {
      const response = await api.get('/roles/permissions/available');
      return response.data;
    } catch (error) {
      console.error('Error fetching available permissions:', error);
      throw error;
    }
  }

  // Duplicate role
  static async duplicateRole(id, newName) {
    try {
      const response = await api.post(`/roles/${id}/duplicate`, { name: newName });
      return response.data;
    } catch (error) {
      console.error('Error duplicating role:', error);
      throw error;
    }
  }
}

export default RoleService;
